import { CancelTokenSource } from 'axios';
import { DiagnosisDto, DiagnosisSearchRequest, ReportDiagnosisDto, UpsertDiagnosisDto } from 'ts-types/api.types';
import axios from './http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/diagnoses`;

export const getAllDiagnoses = (
    source: CancelTokenSource): Promise<Array<DiagnosisDto>> => {

  return axios
      .get(apiUri, {cancelToken: source.token})
      .then((response) => response.data);
};

export const searchDiagnoses = (
    diagnosisSearchRequest: Partial<DiagnosisSearchRequest>,
    source: CancelTokenSource) => {

  return axios
      .post(`${apiUri}/search`, diagnosisSearchRequest, {cancelToken: source.token})
      .then(response => response.data);

};

export const findDiagnosisById = async (
    id: number, source: CancelTokenSource) => {

  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteDiagnosis = (
    id: number, source: CancelTokenSource): Promise<DiagnosisDto> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const addDiagnosis = (
    upsertDiagnosisDto: Partial<UpsertDiagnosisDto>,
    source: CancelTokenSource): Promise<DiagnosisDto> => {

  return axios
      .post(apiUri, upsertDiagnosisDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editDiagnosis = (
    id: number,
    upsertDiagnosisDto: Partial<UpsertDiagnosisDto>,
    source: CancelTokenSource): Promise<DiagnosisDto> => {

  return axios
      .put(`${apiUri}/${id}`, upsertDiagnosisDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const getDiagnosisForReport = (
    patientId: number, source: CancelTokenSource): Promise<Array<ReportDiagnosisDto>> => {

  return axios
      .get(`${apiUri}/report-diagnosis/${patientId}`, {cancelToken: source.token})
      .then(response => response.data);
}
